import { render, staticRenderFns } from "./PublishingProjectsTopSlot.vue?vue&type=template&id=75bfc064"
import script from "./PublishingProjectsTopSlot.vue?vue&type=script&lang=js"
export * from "./PublishingProjectsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports